import React from "react";
import {
  Card,
  Flex,
  Title,
  Box,
  CompanyBarInfoContainer,
  WebsiteEmailContainer,
  TaxIdContactContainer,
  Row,
  BarFieldLabel,
  BarFieldValue,
  LinkText,
  AddressContainer,
  AddressLabel,
  AddressRow,
  AddressValue,
  Button,
} from "../../components/StyledComponents";
import { Address, CustomerInformation } from "./types";
import { EditWhiteIcon } from "./icons";

interface Props {
  customer: CustomerInformation | null;
  companyAddress?: Address;
  onEdit: () => void;
}

export const CustomerCompanyInformation: React.FC<Props> = ({
  customer,
  companyAddress,
  onEdit,
}) => {
  return (
    <Card>
      <Flex>
        <Title>Company Information</Title>

        <Button onClick={onEdit}>
          {" "}
          <EditWhiteIcon /> Edit Information{" "}
        </Button>
      </Flex>
      <Box>
        <CompanyBarInfoContainer>
          <WebsiteEmailContainer>
            <Row>
              <BarFieldLabel>Website:&nbsp;</BarFieldLabel>
              <LinkText>{customer?.organization_domain ?? "-"}</LinkText>
            </Row>

            <Row>
              <BarFieldLabel>Email:&nbsp;</BarFieldLabel>
              <LinkText>{customer?.work_email_address ?? "-"}</LinkText>
            </Row>
          </WebsiteEmailContainer>

          <TaxIdContactContainer>
            <Row>
              <BarFieldLabel>Tax ID:&nbsp;</BarFieldLabel>
              <BarFieldValue>{customer?.tax_id ?? "-"}</BarFieldValue>
            </Row>
            <Row>
              <BarFieldLabel>Contact no.:&nbsp;</BarFieldLabel>
              <BarFieldValue>{customer?.mobile_phone ?? "-"}</BarFieldValue>
            </Row>
          </TaxIdContactContainer>
        </CompanyBarInfoContainer>

        {companyAddress && (
          <AddressContainer>
            <AddressLabel>Company Address:</AddressLabel>
            <AddressRow>
              <Row>
                <AddressLabel>Street:&nbsp;</AddressLabel>
                <AddressValue>{companyAddress.address ?? "-"}</AddressValue>
              </Row>
              <Row>
                <AddressLabel>City:&nbsp;</AddressLabel>
                <AddressValue>{companyAddress.city?.name ?? "-"}</AddressValue>
              </Row>
              <Row>
                <AddressLabel>State:&nbsp;</AddressLabel>
                <AddressValue>{companyAddress.state?.name ?? "-"}</AddressValue>
              </Row>
            </AddressRow>

            <AddressRow>
              <Row>
                <AddressLabel>Zip code:&nbsp;</AddressLabel>
                <AddressValue>{companyAddress.postal_code ?? "-"}</AddressValue>
              </Row>
              <Row>
                <AddressLabel>Country:&nbsp;</AddressLabel>
                <AddressValue>
                  {companyAddress.country?.name ?? "-"}
                </AddressValue>
              </Row>
            </AddressRow>
          </AddressContainer>
        )}
      </Box>
    </Card>
  );
};
